import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../../../modules/material/material.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { TableModule } from "../../shared/components/table/onsip-table.module";
import { TranslateModule } from "@ngx-translate/core";
import { GroupsPageComponent } from "./groupsPage/groups-page.component";
import { GroupShelfContainerComponent } from "./groupShelfContainer/group-shelf-container.component";
import { GroupShelfViewComponent } from "./groupShelfView/group-shelf-view.component";
import { GroupShelfEditComponent } from "./groupShelfEdit/group-shelf-edit.component";
import { EditItemListModule } from "../../shared/components/onsipItemList/edit-item-list.module";
import { ListPickerModule } from "../../shared/components/pickers/listPicker/list-picker.module";
import { SelectionListDeluxeModule } from "../../shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { OnsipFormsModule } from "../../shared/components/forms/onsip-forms.module";
import { FormEventTrackingModule } from "../../shared/components/analytics/form-event-tracking.module";
import { GroupSetupComponent } from "./groupSetup/group-setup.component";
import { GroupsContainerComponent } from "./groupsContainer/groups-container.component";
import { AddressAutocompleteModule } from "../addressAutocomplete/address-autocomplete.module";
import { GroupsRoutingModule } from "@onsip/web/features/administrators/groups/groupsRouting.module";
import { ExtensionsListModule } from "@onsip/web/features/shared/components/extensionsList/extensions-list.module";
import { PhoneNumberListModule } from "../../shared/components/phoneNumberList/phone-number-list.module";
import { SipAddressFieldModule } from "../../shared/components/sipAddressField/sip-address-field.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { AlphabeticalSelectionListModule } from "@onsip/web/features/shared/components/alphabeticalSelectionList/alphabetical-selection-list.module";
import { GroupShelfMembersEditComponent } from "@onsip/web/features/administrators/groups/groupShelfMembersEdit/group-shelf-members-edit.component";
import { GroupShelfMembersViewComponent } from "@onsip/web/features/administrators/groups/groupShelfMembersView/group-shelf-members-view.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { SelectMemberDragDropComponent } from "./selectMemberDragAndDrop/select-member-drag-drop.component";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    RouterModule,
    PipesModule,
    TableModule,
    EditItemListModule,
    ListPickerModule,
    SelectionListDeluxeModule,
    OnsipFormsModule,
    FormEventTrackingModule,
    AddressAutocompleteModule,
    GroupsRoutingModule,
    SipAddressFieldModule,
    ExtensionsListModule,
    PhoneNumberListModule,
    TableDataLoadContainerModule,
    AlphabeticalSelectionListModule,
    DragDropModule,
    LoadingContainerComponent
  ],
  declarations: [
    GroupsPageComponent,
    GroupShelfContainerComponent,
    GroupShelfViewComponent,
    GroupShelfEditComponent,
    GroupSetupComponent,
    GroupsContainerComponent,
    GroupShelfMembersEditComponent,
    GroupShelfMembersViewComponent,
    SelectMemberDragDropComponent
  ]
})
export class GroupsModule {}
